import React, { useState, useEffect } from 'react';
import { Form, Button, Input, message, InputNumber, Select, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { toFormData } from '../../util/FormData';

const layout = {
	labelCol: {
		span: 6,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 6,
		span: 16,
	},
};

const usedCarMinDownPayment = [
	{ downPercent: 15 },
	{ downPercent: 20 },
	{ downPercent: 25 },
	{ downPercent: 30 },
	{ downPercent: 35 },
	{ downPercent: 40 },
	{ downPercent: 45 },
	{ downPercent: 50 },
];
const newCarMinDownPayment = [
	{ downPercent: 10 },
	{ downPercent: 15 },
	{ downPercent: 20 },
	{ downPercent: 25 },
	{ downPercent: 30 },
	{ downPercent: 35 },
	{ downPercent: 40 },
	{ downPercent: 45 },
	{ downPercent: 50 },
];

const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const BankPostForm = ({ addBank }) => {
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);
	const [carType, setCarType] = useState();
	const [usedDownPayment, setUsedDownPayment] = useState();
	const [newDownPayment, setNewDownPayment] = useState();

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	const onFinish = async (values) => {
		values.image = imageList[0];
		const data = toFormData(values);
		await addBank(data);
		message.success('bank posted successfully!');
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="bankForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Name" name={['name']} rules={InputRules.required('Please enter name!')}>
				<Input placeholder="Enter bank name" />
			</Form.Item>
			<Form.Item label="Website" name={['url']} rules={InputRules.required('Please enter bank website!')}>
				<Input placeholder="Enter bank website" />
			</Form.Item>
			<Form.Item label="Upload Image" name={['image']}>
				<Upload
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
					maxCount={1}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item
				label="Bank Interest Rate"
				name={['bankInterest']}
				rules={InputRules.required('Please enter interest rate!')}
			>
				<InputNumber placeholder="Enter interest rate" />
			</Form.Item>
			<Form.Item
				label="Kibor Interest Rate"
				name={['kiborInterest']}
				rules={InputRules.required('Please enter interest rate!')}
			>
				<InputNumber placeholder="Enter interest rate" />
			</Form.Item>
			<Form.Item
				label="Insurance Interest Rate"
				name={['insuranceInterest']}
				rules={InputRules.required('Please enter interest rate!')}
			>
				<InputNumber placeholder="Enter interest rate" />
			</Form.Item>
			<Form.Item label="Min Term" name={['minTerm']} rules={InputRules.required('Please enter min term!')}>
				<InputNumber placeholder="Enter min term" />
			</Form.Item>
			<Form.Item label="Max Term" name={['maxTerm']} rules={InputRules.required('Please enter max term!')}>
				<InputNumber placeholder="Enter max term" />
			</Form.Item>
			<Form.Item label="Car Type Processed" name={['carType']} rules={InputRules.required('Select car type!')}>
				<Select placeholder="Select car type" onChange={(value) => setCarType(value)}>
					<Select.Option value="used">Used</Select.Option>
					<Select.Option value="new">New</Select.Option>
					<Select.Option value="both">Both</Select.Option>
				</Select>
			</Form.Item>
			{carType === 'both' && (
				<>
					<Form.Item
						label="Min % For Used Cars"
						name={['usedCarDownPayment']}
						rules={InputRules.required('Select used car down payment!')}
					>
						<Select
							showSearch
							allowClear={true}
							placeholder="Select used car min down payment"
							onChange={(value) => setUsedDownPayment(value)}
						>
							{usedCarMinDownPayment?.map((usedCarDownPayment) => (
								<Select.Option value={usedCarDownPayment.downPercent} key={usedCarDownPayment.downPercent}>
									{`${usedCarDownPayment?.downPercent}%`}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item
						label="Min % For New Cars"
						name={['newCarDownPayment']}
						rules={InputRules.required('Select new car down payment!')}
					>
						<Select
							showSearch
							allowClear={true}
							placeholder="Select new car min down payment"
							onChange={(value) => setNewDownPayment(value)}
						>
							{newCarMinDownPayment?.map((newCarMinDownPayment) => (
								<Select.Option value={newCarMinDownPayment.downPercent} key={newCarMinDownPayment.downPercent}>
									{`${newCarMinDownPayment?.downPercent}%`}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</>
			)}
			{carType === 'used' && (
				<Form.Item
					label="Min % For Used Cars"
					name={['usedCarDownPayment']}
					rules={InputRules.required('Select used car down payment!')}
				>
					<Select
						showSearch
						allowClear={true}
						placeholder="Select used car min down payment"
						onChange={(value) => setUsedDownPayment(value)}
					>
						{usedCarMinDownPayment?.map((usedCarMinDownPayment) => (
							<Select.Option value={usedCarMinDownPayment.downPercent} key={usedCarMinDownPayment.downPercent}>
								{`${usedCarMinDownPayment?.downPercent}%`}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			)}
			{carType === 'new' && (
				<Form.Item
					label="Min % For New Cars"
					name={['newCarDownPayment']}
					rules={InputRules.required('Select new car down payment!')}
				>
					<Select
						showSearch
						allowClear={true}
						placeholder="Select new car min down payment"
						onChange={(value) => setNewDownPayment(value)}
					>
						{newCarMinDownPayment?.map((newCarMinDownPayment) => (
							<Select.Option value={newCarMinDownPayment.downPercent} key={newCarMinDownPayment.downPercent}>
								{`${newCarMinDownPayment?.downPercent}%`}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			)}
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Bank
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	addBank: (body) => dispatch(Actions.addBank(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BankPostForm);
